import React, { useCallback, useState } from 'react'
import { FieldPath, useForm } from 'react-hook-form'

import { Link } from 'UI'
import { LinkStyles } from 'UI/Link/types'
import TasksTabs from 'containers/Courses/Entities/Tasks/Tabs/Create/Wrapper.container'
import { ITask } from 'types/models/task.model'

import { useParams } from 'react-router-dom'
import CancelChangeModal from 'pages/Course/modals/CancelChangeModal'
import cl from '../style.module.scss'

export interface TaskFormState extends ITask<string> { }

const TaskCreatePage = () => {
	const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false)

	const { courseId } = useParams()

	const { register, handleSubmit, setValue, control, formState } =
		useForm<TaskFormState>()

	const changeHandler = useCallback(
		(name: FieldPath<TaskFormState>) => (value: any) => setValue(name, value),
		[]
	)

	return (
		<>
			<CancelChangeModal
				isOpen={cancelModalIsOpen}
				onClose={() => setCancelModalIsOpen(false)}
				redirectUri={`/course/edit/${courseId}`}
			/>
			<div className={cl.container}>
				<div className={cl.back}>
					<Link
						styleTypes={[LinkStyles.GO_BACK]}
						href={`/course/edit/${courseId}`}
					>
						Вернуться назад к курсу
					</Link>
				</div>
				<div className={cl.header}>
					<div className={cl.headerLessonInfo}>
						<h2>Новое задание</h2>
					</div>
				</div>
				<TasksTabs
					onOpenCanceledChange={() => setCancelModalIsOpen(true)}
					handleSubmit={handleSubmit}
					errors={formState.errors}
					onChange={changeHandler}
					control={control}
					register={register}
				/>
			</div>
		</>
	)
}

export default TaskCreatePage
